var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C3.04482 0 0.640625 2.4042 0.640625 5.35938C0.640625 6.3053 0.890547 7.23529 1.36335 8.04877C1.47357 8.23843 1.59678 8.42324 1.72962 8.59811L5.76714 14H6.23283L10.2704 8.59813C10.4032 8.42324 10.5264 8.23845 10.6367 8.0488C11.1095 7.23529 11.3594 6.3053 11.3594 5.35938C11.3594 2.4042 8.95518 0 6 0ZM6 7.13672C5.01997 7.13672 4.22266 6.3394 4.22266 5.35938C4.22266 4.37935 5.01997 3.58203 6 3.58203C6.98003 3.58203 7.77734 4.37935 7.77734 5.35938C7.77734 6.3394 6.98003 7.13672 6 7.13672Z",
    fill: "#929AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/GroupIcon.60436cefc50c33014e63ab3daa4e12b1.svg";
export { ForwardRef as ReactComponent };